import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export enum ImageProviders {
  CANTO = 'CANTO',
  RAW = 'RAW',
}

export enum ImageFileTypes {
  PNG = 'PNG',
  JPG = 'JPG',
  TIF = 'TIF',
  GIF = 'GIF',
  WEBP = 'WEBP',
}

export interface CantoParameters {
  width: number;
  height: number;
  fileType: ImageFileTypes;
}

@Pipe({ name: 'ImageUrl' })
export class ImageUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(
    resource: string | undefined,
    provider: string | undefined = ImageProviders.RAW,
    cantoParameters: CantoParameters = {
      width: 1200,
      height: 675,
      fileType: ImageFileTypes.WEBP,
    }
  ): string {
    if (!resource) {
      return '';
    }

    if (!provider) {
      provider = ImageProviders.RAW;
    }

    if (provider === ImageProviders.CANTO) {
      // Remove tailing slash
      const resourceUrl = resource.replace(/\/+$/, '');
      const transformedResourceUrl =
        resourceUrl + '/-S' + cantoParameters.width + 'x' + cantoParameters.height + '-F' + cantoParameters.fileType;

      // Set transformation parameters and return modified resource url
      return (
        this.sanitizer.sanitize(
          SecurityContext.RESOURCE_URL,
          this.sanitizer.bypassSecurityTrustResourceUrl(transformedResourceUrl)
        ) ?? ''
      );
    }

    // Return original resource url
    return (
      this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(resource)) ??
      ''
    );
  }
}
